import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { useTranslation } from "react-i18next";
import AddBoxIcon from "@material-ui/icons/AddBox";
import {  Formik } from "formik";
import * as YUP from "yup";
import { v4 as uuidv4 } from "uuid";
import { WorkerService } from "../../../services";
import DeleteIcon from '@material-ui/icons/Delete';
 

const VocationalTraining = (props) => {
  const dropZone = useRef();
  const { t } = useTranslation();
  const [rows, setRows] = useState(props.values.vocationalTrainingList); 
const initialValues={
  id: uuidv4(),
  trainingName: "",
  beginDate: "",
  completionDate: "",
  imagePath: null,
  trainingTypeCode: "",
}
 
  const validationSchema = YUP.object({});

  const onSubmit = (values, { resetForm ,setFieldValue}) => {
    var xx = rows;
    xx.push({ ...values});
    setRows(xx); 
   var  yy =[];
   rows.map(row=>yy.push({...row,id:0}))
    props.setFieldValue("vocationalTrainingList", yy);
    resetForm({});
    dropZone.current.state.fileObjects.forEach((file,index)=>{
      dropZone.current.deleteFile(file,index)
    }); 
  };

  const onDelete = (id) => { 
    const newRows = rows.filter(xx=>xx.id!==id); 
    props.setFieldValue("vocationalTrainingList", newRows); 
    setRows(newRows);
  };

  /*
  const	downloadEmployeeData = (filePath) => {
    axios({
      url: filePath,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.pdf');
      document.body.appendChild(link);
      link.click();
    });
	}
  */

  return (
    <Card>
      <CardHeader
        title={t("pages.workerregister.vocationalTraining.stepname")}
      />
      <Divider />
      <CardContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit} 
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue,
            resetForm
          }) => (
            <>
             
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={t(
                      "workervocationaltraining.workerVocationalTrainingName"
                    )}
                    name="trainingName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.trainingName}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Training Type"
                    name="trainingTypeCode"
                    select
                    SelectProps={{ native: true }}
                    error={Boolean(
                      touched.trainingTypeCode && errors.trainingTypeCode
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.trainingTypeCode}
                  >
                    {props.vocationalTrainingType?.map((option) => (
                      <option
                        key={option.metadataCode}
                        value={option.metadataCode}
                      >
                        {option.metadataValue}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label={t("workervocationaltraining.beginDate")}
                    name="beginDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.beginDate}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label={t("workervocationaltraining.completionDate")}
                    name="completionDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.completionDate}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Box p={2} m={2}>
                    <DropzoneArea
                     ref={dropZone}
                      dropzoneText={
                        "Drag and drop an Diploma image here or click"
                      }
                      filesLimit={1}
                      showFileNames
                      name="imagePath"
                      onChange={(files) => { 
                        if (files && files.length > 0) {
                          WorkerService.UPLOAD_FILE(files[0], files[0].name)
                            .then((response) => {
                              const { message } = response.data;
                              setFieldValue("imagePath", message);
                            })
                            .catch((err) => {
                              console.log("file-err", err);
                            });
                        }
                      }}
                      onDelete={(files) => {
                        setFieldValue("imagePath", undefined);
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box display="flex" justifyContent="center">
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<AddBoxIcon />}
                      onClick={handleSubmit}
                    >
                      Add
                    </Button>
                  </Box>
                </Grid>
                <Grid item md={12} xs={12}>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Training Name</TableCell>
                          <TableCell>Begin Date</TableCell>
                          <TableCell>Completion Date</TableCell>
                          <TableCell>Training Type</TableCell>
                          <TableCell>File Path</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.trainingName}</TableCell>
                            <TableCell>{row.beginDate}</TableCell>
                            <TableCell>{row.completionDate}</TableCell>
                            <TableCell>{row.trainingTypeCode}</TableCell>
                            <TableCell>
                              {row.imagePath}
                              {/* <a href="#" onClick={downloadEmployeeData(row.imagePath)}>Download</a> */}                              
                            </TableCell>
                            <TableCell> <IconButton aria-label="delete" onClick={()=>onDelete(row.id)} ><DeleteIcon/></IconButton></TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              
              {/* This state
              <pre>{JSON.stringify(values, null, 2)}</pre>
              Master state
              <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
            </>
          )}
        </Formik>
      </CardContent>
      <Divider />
    </Card>
  );
};

export default VocationalTraining;
